import BoilerView from "./BoilerView";

export default BoilerView;